import createTransactionsAPI from "@/helpers/rtk_transactions_resource_factory";
import { getCurrentUser } from "@/helpers/session_helper";

const baseURL = process.env.REACT_APP_GLOBO_API + "/transactions/lOARequests";
const type = "LOARequests";
const currentUser = getCurrentUser()

export const lOARequestsAPI = createTransactionsAPI({
  baseURL: baseURL,
  resource: "LOARequests",
  tagTypes: ["LOARequests"],
  idKey: "loaRequestId",
  lookupMap: ({ loaRequestId, referenceNo }) => ({
    value: loaRequestId,
    label: referenceNo,
  }),
  customQuery: (query, { idKey, resource, baseURL }) => ({
    getListLOARequestsForViewers: query(`${baseURL}/listForViewer`, {
      serializeQueryArgs: ({ endpointName }) => endpointName,
      providesTags: (result) => {
        if (!result?.success || !Array.isArray(result.returnData)) {
          return [{ type: resource, id: "LIST" }];
        }

        return [
          ...result.returnData.map((item) => ({
            type: resource,
            id: item[idKey],
          })),
          { type: resource, id: "LIST" },
        ];
      },
    }),
    getFilesLOARequests: query(`${baseURL}/files/list`, {
      serializeQueryArgs: ({ endpointName }) => endpointName,
      providesTags: (result) =>
        result?.success
          ? [...(result?.items || result?.returnData)?.map((item) => ({ type: type, id: item[idKey] })), { type: type, id: type }]
          : [{ type: type, id: type }],
    }),
  }),
  customMutations: (mutation, mutationOptions, builder) => ({

    submitLOARequests: mutation(`${baseURL}/submit`, mutationOptions("save")),
    returnLOARequests: mutation(`${baseURL}/return`, mutationOptions("save")),
    approveLOARequests: mutation(`${baseURL}/approve`, mutationOptions("save")),
    rejectLOARequests: mutation(`${baseURL}/reject`, mutationOptions("save")),
    cancelLOARequests: mutation(`${baseURL}/cancel`, mutationOptions("save")),
    uploadLOAFileRequests: mutation(`${baseURL}/uploadLOAFile`, mutationOptions("save")),
    filesUploadLOARequests: mutation(`${baseURL}/files/upload`),
    filesDeleteLOARequests: mutation(`${baseURL}/files/delete`),

    exportListForViewerLOAFileRequests: builder.mutation({
      query: (params) => ({
        url: `${baseURL}/exportListForViewer`,
        method: "POST",
        body: params,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${currentUser?.token}`,
        },
      }),
      async onQueryStarted(params, { queryFulfilled }) {
        try {
          const response = await fetch(`${baseURL}/exportListForViewer`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${currentUser?.token}`,
            },
            body: JSON.stringify(params),
          });

          if (!response.ok) throw new Error("Export failed");

          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `LOAFileRequests-Viewer-${new Date().toISOString().split("T")[0]}.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          await queryFulfilled.catch(() => { });
        } catch (err) {
          console.error("Export failed:", err);
          throw err;
        }
      },
    }),
  }),
});

export const {
  useGetLOARequestsQuery,
  useGetListLOARequestsForViewersQuery,
  useExportLOARequestsMutation,
  useFindLOARequestsQuery,
  useLookUpLOARequestsMutation,
  useSaveLOARequestsMutation,
  useSubmitLOARequestsMutation,
  useReturnLOARequestsMutation,
  useApproveLOARequestsMutation,
  useRejectLOARequestsMutation,
  useCancelLOARequestsMutation,
  useDeleteLOARequestsMutation,
  useFilesUploadLOARequestsMutation,
  useUploadLOAFileRequestsMutation,
  useFilesDeleteLOARequestsMutation,
  useGetFilesLOARequestsQuery,
  useExportListForViewerLOAFileRequestsMutation
} = lOARequestsAPI;
